export default __webpack_public_path__ + "static/media/logo_lvv_admin_white.66b02033.svg";